import { Box, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface VariableChipProps {
  name: string;
  /** When true, the variable is not in the Variables list — shown in warning colour */
  isMissing?: boolean;
}

/**
 * Inline chip rendered inside a VoiceSegmentNode in display mode.
 * Represents a {{variableName}} placeholder.
 */
export const VariableChip = ({
  name,
  isMissing = false,
}: VariableChipProps): React.ReactNode => {
  const theme = useTheme();

  return (
    <Tooltip title={`{{${name}}}`} placement="top">
      <Box
        component="span"
        sx={{
          display: "inline",
          color: isMissing
            ? theme.palette.warning.main
            : theme.palette.primary.main,
          textDecoration: "underline",
          textDecorationStyle: "dotted",
          textDecorationThickness: "2px",
          textUnderlineOffset: "2px",
          fontSize: "12px",
          fontFamily: "monospace",
          mx: "1px",
          cursor: "default",
          userSelect: "none",
        }}
      >
        {name}
      </Box>
    </Tooltip>
  );
};
